const normalizeBase = (value: string) => value.replace(/\/+$/, '');

export const API_BASE = (() => {
  const envBase = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (envBase) {
    return normalizeBase(envBase);
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:5001';
  }

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:5001';
  }

  return normalizeBase(window.location.origin);
})();
